import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import BottomNav from "./BottomNav";
import QuickAdd from "./QuickAdd";

export default function AppShell() {
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col overflow-x-hidden">
        <TopBar />
        <main className="mx-auto w-full max-w-[1400px] flex-1 px-4 py-6 pb-32 sm:px-6 md:pb-12 lg:px-10">
          <Outlet />
        </main>
      </div>
      <BottomNav />
      <QuickAdd />
    </div>
  );
}
